// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"#1b2d63","borderColor":"#2271a0","borderWidth":"4px"};